<style lang="less" scoped>
.ai-markdown-stream-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.ai-markdown-stream-toolbar {
  flex-shrink: 0;
  padding-bottom: 8px;
}
.ai-markdown-stream-body {
  flex: 1;
  min-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 28px 32px 32px;
  background: #fff;
  border: 1px solid var(--border);
  position: relative;
  max-width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
/* Markdown 区域不出现横向滚动，长行自动换行 */
.ai-markdown-stream-body /deep/ .mdmdt {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.75;
  font-size: 15px;
  color: #1e293b;
}
/* 正文段落：首行缩进 + 略宽行距（列表/引用内段落不缩进） */
.ai-markdown-stream-body /deep/ .mdmdt p {
  text-indent: 2em;
  line-height: 1.8;
  margin: 0.65em 0;
}
.ai-markdown-stream-body /deep/ .mdmdt li p {
  text-indent: 0;
  margin: 0.35em 0;
  line-height: 1.75;
}
.ai-markdown-stream-body /deep/ .mdmdt h1,
.ai-markdown-stream-body /deep/ .mdmdt h2,
.ai-markdown-stream-body /deep/ .mdmdt h3,
.ai-markdown-stream-body /deep/ .mdmdt h4,
.ai-markdown-stream-body /deep/ .mdmdt h5,
.ai-markdown-stream-body /deep/ .mdmdt h6 {
  text-indent: 0;
  text-align: left !important;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
  margin-top: 1.15em;
  margin-bottom: 0.45em;
}
.ai-markdown-stream-body /deep/ .mdmdt h1 {
  font-size: 1.5rem;
  font-weight: 700;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.35em;
}
.ai-markdown-stream-body /deep/ .mdmdt h2 {
  font-size: 1.3rem;
}
.ai-markdown-stream-body /deep/ .mdmdt h3 {
  font-size: 1.15rem;
}
.ai-markdown-stream-body /deep/ .mdmdt h4 {
  font-size: 1.05rem;
}
.ai-markdown-stream-body /deep/ .mdmdt h5,
.ai-markdown-stream-body /deep/ .mdmdt h6 {
  font-size: 1rem;
  font-weight: 600;
}
.ai-markdown-stream-body /deep/ .mdmdt hr + p,
.ai-markdown-stream-body /deep/ .mdmdt h1 + p,
.ai-markdown-stream-body /deep/ .mdmdt h2 + p,
.ai-markdown-stream-body /deep/ .mdmdt h3 + p {
  margin-top: 0.75em;
}
.ai-markdown-stream-body /deep/ .mdmdt ul,
.ai-markdown-stream-body /deep/ .mdmdt ol {
  line-height: 1.75;
  padding-left: 1.5em;
}
.ai-markdown-stream-body /deep/ .mdmdt blockquote {
  line-height: 1.75;
}
.ai-markdown-stream-body /deep/ .mdmdt blockquote p {
  text-indent: 0;
}
.ai-markdown-stream-body /deep/ .mdmdt pre {
  text-indent: 0;
  line-height: 1.5;
}
.ai-markdown-stream-body /deep/ .mdmdt pre,
.ai-markdown-stream-body /deep/ .mdmdt code {
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 100%;
}
.ai-markdown-stream-body /deep/ .mdmdt img,
.ai-markdown-stream-body /deep/ .mdmdt video {
  max-width: 100%;
  height: auto;
}
.ai-markdown-stream-body /deep/ .mdmdt table {
  width: 100%;
  table-layout: fixed;
  word-wrap: break-word;
}
.ai-markdown-stream-body /deep/ .mdmdt th,
.ai-markdown-stream-body /deep/ .mdmdt td {
  word-break: break-word;
}
.ai-markdown-placeholder {
  color: #999;
  padding: 32px 16px;
  text-align: center;
  line-height: 1.6;
}
.ai-markdown-streaming-tip {
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 2;
  font-size: 12px;
  color: var(--primary, #2d8cf0);
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--border);
}
</style>
<template>
  <div class="ai-markdown-stream-panel">
    <div v-if="$slots.toolbar" class="ai-markdown-stream-toolbar">
      <slot name="toolbar" />
    </div>
    <div ref="scrollBody" class="ai-markdown-stream-body pdf-export">
      <div v-if="streaming" class="ai-markdown-streaming-tip">正在生成…</div>
      <div v-if="showPlaceholder" class="ai-markdown-placeholder">
        {{ placeholder }}
      </div>
      <BaseMarkdownView v-else ref="content" :value="value" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiMarkdownStreamPanel',
  props: {
    value: {
      type: String,
      default: '',
    },
    streaming: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '选择提示词后点击「生成报告」，流式结果将显示在此。',
    },
  },
  computed: {
    showPlaceholder() {
      return !this.streaming && !(this.value && String(this.value).trim());
    },
  },
  watch: {
    value() {
      if (this.streaming) {
        this.$nextTick(() => this.scrollToBottom());
      }
    },
    streaming(v) {
      if (!v) {
        this.$nextTick(() => this.scrollToBottom());
      }
    },
  },
  methods: {
    /** 供 html2pdf 等使用：与原先 BaseMarkdownView 根节点一致 */
    getPdfElement() {
      if (this.$refs.content && this.$refs.content.$el) {
        return this.$refs.content.$el;
      }
      return this.$refs.scrollBody;
    },
    scrollToBottom() {
      const el = this.$refs.scrollBody;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
  },
};
</script>
